import { createEntityAdapter } from '@reduxjs/toolkit';
import type {
  Audit,
  AuthUser,
  Company,
  Credit,
  Document,
  Enquiry,
  Enrolment,
  Enterprise,
  Event,
  InfoAuth,
  InfoCompany,
  InfoEnquiry,
  InfoEntity,
  InfoGhost,
  InfoIP,
  InfoIntroductionStats,
  InfoLead,
  InfoOnboarding,
  InfoQuery,
  InfoRelation,
  InfoSearch,
  InfoStats,
  InfoTag,
  InfoWorkType,
  Introduction,
  Job,
  Lead,
  Monitor,
  Onboarding,
  Partner,
  Payment,
  Rate,
  Subscription,
  Tag,
  TradeSummary,
  Training,
  Transaction,
  RedirectURLs,
  Referral,
  ExportCSV,
  ExportJSON,
  InfoSession,
  Cache,
  Campaign,
  Customer,
  OwnerReport,
  EnterpriseUserRole,
  Error,
  InfoPartnerBranding,
  InfoLegacyRedirect,
  InfoCheckoutRedirect,
  InfoValidationEmail,
  JobCreditState,
  Tally,
  JobCompanyInfo,
  LeadJobSummary,
} from '../../generated/components/schemas';
export const auditAdapter = createEntityAdapter<Audit>();
export const authUserAdapter = createEntityAdapter<AuthUser>();
export const companyAdapter = createEntityAdapter<Company>();
export const creditAdapter = createEntityAdapter<Credit>();
export const documentAdapter = createEntityAdapter<Document>();
export const enquiryAdapter = createEntityAdapter<Enquiry>();
export const enrolmentAdapter = createEntityAdapter<Enrolment>();
export const enterpriseAdapter = createEntityAdapter<Enterprise>();
export const eventAdapter = createEntityAdapter<Event>();
export const infoAuthAdapter = createEntityAdapter<InfoAuth>();
export const infoCompanyAdapter = createEntityAdapter<InfoCompany>();
export const infoEnquiryAdapter = createEntityAdapter<InfoEnquiry>();
export const infoEntityAdapter = createEntityAdapter<InfoEntity>();
export const infoGhostAdapter = createEntityAdapter<InfoGhost>();
export const infoIPAdapter = createEntityAdapter<InfoIP>();
export const infoIntroductionStatsAdapter =
  createEntityAdapter<InfoIntroductionStats>();
export const infoLeadAdapter = createEntityAdapter<InfoLead>();
export const infoOnboardingAdapter = createEntityAdapter<InfoOnboarding>();
export const infoQueryAdapter = createEntityAdapter<InfoQuery>();
export const infoRelationAdapter = createEntityAdapter<InfoRelation>();
export const infoSearchAdapter = createEntityAdapter<InfoSearch>();
export const infoStatsAdapter = createEntityAdapter<InfoStats>();
export const infoTagAdapter = createEntityAdapter<InfoTag>();
export const infoWorkTypeAdapter = createEntityAdapter<InfoWorkType>();
export const introductionAdapter = createEntityAdapter<Introduction>();
export const jobAdapter = createEntityAdapter<Job>();
export const leadAdapter = createEntityAdapter<Lead>();
export const monitorAdapter = createEntityAdapter<Monitor>();
export const onboardingAdapter = createEntityAdapter<Onboarding>();
export const partnerAdapter = createEntityAdapter<Partner>();
export const paymentAdapter = createEntityAdapter<Payment>();
export const rateAdapter = createEntityAdapter<Rate>();
export const subscriptionAdapter = createEntityAdapter<Subscription>();
export const tagAdapter = createEntityAdapter<Tag>();
export const tradeSummaryAdapter = createEntityAdapter<TradeSummary>();
export const trainingAdapter = createEntityAdapter<Training>();
export const transactionAdapter = createEntityAdapter<Transaction>();
export const postCompanyBillingAdapter = createEntityAdapter<RedirectURLs>();
export const getCompanyDirectorVerificationAdapter =
  createEntityAdapter<InfoCompany>();
export const postCompanyDirectorVerificationAdapter =
  createEntityAdapter<InfoCompany>();
export const getCompanyReferralsAdapter = createEntityAdapter<Referral>();
export const postCompanyReferralsAdapter = createEntityAdapter<Referral>();
export const exportFcaApprovedAdapter = createEntityAdapter<ExportCSV>();
export const importFcaApprovedAdapter = createEntityAdapter<ExportCSV>();
export const exportEnterpriseDailyReportAdapter =
  createEntityAdapter<ExportJSON>();
export const infoSessionAdapter = createEntityAdapter<InfoSession>();
export const infoGetCacheAdapter = createEntityAdapter<Cache>();
export const infoPutCacheAdapter = createEntityAdapter<Cache>();
export const infoDeleteCacheAdapter = createEntityAdapter<Cache>();
export const infoCampaignAdapter = createEntityAdapter<Campaign>();
export const infoCustomerAdapter = createEntityAdapter<Customer>();
export const infoDirectorAdapter = createEntityAdapter<OwnerReport>();
export const infoEnterpriseRoleAdapter =
  createEntityAdapter<EnterpriseUserRole>();
export const infoEnterpriseAdapter = createEntityAdapter<Enterprise>();
export const infoHealthAdapter = createEntityAdapter<Error>();
export const infoPartnerBrandingAdapter =
  createEntityAdapter<InfoPartnerBranding>();
export const infoLegacyRedirectAdapter =
  createEntityAdapter<InfoLegacyRedirect>();
export const infoCheckoutRedirectAdapter =
  createEntityAdapter<InfoCheckoutRedirect>();
export const infoValidateEmailAdapter =
  createEntityAdapter<InfoValidationEmail>();
export const checkJobAdapter = createEntityAdapter<JobCreditState>();
export const payoutsJobAdapter = createEntityAdapter<Tally>();
export const jobCheckoutLinkAdapter = createEntityAdapter<RedirectURLs>();
export const jobCompanyInfoAdapter = createEntityAdapter<JobCompanyInfo>();
export const exportJobPayoutsAdapter = createEntityAdapter<ExportCSV>();
export const tradeQuoteApprovalLeadAdapter = createEntityAdapter<Job>();
export const matchTradesLeadAdapter = createEntityAdapter<TradeSummary>();
export const connectTradesLeadAdapter = createEntityAdapter<TradeSummary>();
export const acceptedJobSummaryLeadAdapter =
  createEntityAdapter<LeadJobSummary>();
